// src/pages/Consultation/Components/SessionStats.jsx
import React from "react";
import {
  FiUsers,
  FiClock,
  FiDollarSign,
  FiTrendingUp,
  FiPause,
} from "react-icons/fi";

const SessionStats = ({ stats }) => {
  const statCards = [
    {
      label: "Active Sessions",
      value: stats.totalActive,
      icon: FiUsers,
      color: "green",
      bgColor: "bg-green-100",
      textColor: "text-green-700",
    },
    {
      label: "Paused Sessions",
      value: stats.totalPaused,
      icon: FiPause,
      color: "yellow",
      bgColor: "bg-yellow-100",
      textColor: "text-yellow-700",
    },
    {
      label: "Total Cart Value",
      value: `₹${(stats.totalCartValue || 0).toLocaleString("en-IN")}`,
      icon: FiDollarSign,
      color: "primary",
      bgColor: "bg-primary/10",
      textColor: "text-primary",
    },
    {
      label: "Avg Duration",
      value: `${stats.avgDuration || 0} min`,
      icon: FiClock,
      color: "blue",
      bgColor: "bg-blue-100",
      textColor: "text-blue-700",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards.map((stat, index) => (
        <div key={index} className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center justify-between mb-2">
            <div className={`p-2 rounded-lg ${stat.bgColor}`}>
              <stat.icon className={`text-2xl ${stat.textColor}`} />
            </div>
          </div>
          <p className="text-sm text-gray-600 mb-1">{stat.label}</p>
          <p className={`text-2xl font-bold ${stat.textColor}`}>{stat.value}</p>
        </div>
      ))}
    </div>
  );
};

export default SessionStats;
